/**
 * API client for pipe hook test functionality
 * Handles communication with the Cloud Function that runs the pipe_hook test
 */

const CLOUD_FUNCTION_BASE_URL = 'https://us-east4-sabal-some.cloudfunctions.net';

/**
 * Run the pipe hook test and return results
 * 
 * @returns {Promise<Object>} Test results including pass/fail status and metrics
 */
export const runPipeHookTest = async (authToken) => {
  try {
    if (!authToken) {
      throw new Error('An authenticated SOMEAC session is required to run the pipe hook test');
    }
    const response = await fetch(`${CLOUD_FUNCTION_BASE_URL}/runPipeHookTest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({}), // Empty body for now, could add test parameters later
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error running pipe hook test:', error);
    throw error;
  }
};

/**
 * Get the status of the pipe hook test function
 * 
 * @returns {Promise<Object>} Function status information
 */
export const getPipeHookTestStatus = async () => {
  try {
    const response = await fetch(`${CLOUD_FUNCTION_BASE_URL}/runPipeHookTest`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      available: response.ok,
      status: response.status,
      statusText: response.statusText,
    };
  } catch (error) {
    console.error('Error checking pipe hook test status:', error);
    return {
      available: false,
      error: error.message,
    };
  }
};
